import { useState } from 'react';
import useReveal from '../hooks/useReveal';
import { useBusinessSettings } from '../context/BusinessSettingsContext';

function SpecialCard({ item, formatPrice, onAddToCart }) {
  const [added, setAdded] = useState(false);

  const handleAdd = () => {
    if (item.soldOut) return;
    onAddToCart(item);
    setAdded(true);
    setTimeout(() => setAdded(false), 800);
  };

  return (
    <div
      style={{
        background: 'rgba(255,255,255,0.07)',
        backdropFilter: 'blur(10px)',
        border: '1px solid rgba(255,255,255,0.12)',
        borderRadius: 'var(--radius)',
        padding: '1.5rem',
        transition: 'all .28s ease',
        cursor: 'pointer',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = 'rgba(255,255,255,0.13)';
        e.currentTarget.style.transform = 'translateY(-4px)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = 'rgba(255,255,255,0.07)';
        e.currentTarget.style.transform = 'none';
      }}
    >
      <div style={{ fontSize: '2.5rem', marginBottom: '.75rem' }}>{item.emoji}</div>
      <div style={{ fontFamily: 'var(--font-display)', fontSize: '1.1rem', color: 'white', marginBottom: '.4rem' }}>
        {item.name}
      </div>
      <div style={{ color: 'rgba(255,255,255,0.58)', fontSize: '.83rem', lineHeight: 1.55, marginBottom: '1.1rem' }}>
        {item.desc}
      </div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <span style={{ color: 'var(--gold-light)', fontWeight: 700, fontSize: '1.1rem', fontFamily: 'var(--font-display)' }}>
          {formatPrice(item.price)}
        </span>
        {!item.soldOut ? (
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              handleAdd();
            }}
            aria-label={`Add ${item.name} to order`}
            style={{
              width: 38,
              height: 38,
              background: added ? 'var(--gold)' : 'var(--teal)',
              border: 'none',
              borderRadius: '50%',
              color: 'white',
              fontSize: '1.3rem',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'all .22s cubic-bezier(.34, 1.56, .64, 1)',
              transform: added ? 'scale(1.35)' : 'scale(1)',
              lineHeight: 1,
              cursor: 'pointer',
              flexShrink: 0,
            }}
          >
            {added ? '✓' : '+'}
          </button>
        ) : (
          <span style={{ color: 'rgba(255,255,255,0.55)', fontSize: '.76rem', fontWeight: 600 }}>
            Unavailable
          </span>
        )}
      </div>
    </div>
  );
}

export default function SpecialsSection({ menuItems, onAddToCart }) {
  const { formatPrice } = useBusinessSettings();
  const revealRef = useReveal();
  const specials = menuItems.filter((i) => i.featured && i.active);

  return (
    <section
      id="specials"
      className="section"
      style={{
        background: 'linear-gradient(135deg, var(--teal-dark) 0%, var(--teal-deeper) 60%, #0a2e38 100%)',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Subtle dot pattern */}
      <div
        aria-hidden="true"
        style={{
          position: 'absolute', inset: 0,
          backgroundImage: 'radial-gradient(rgba(255,255,255,0.04) 1px, transparent 1px)',
          backgroundSize: '28px 28px',
          pointerEvents: 'none',
        }}
      />

      <div className="section-inner" style={{ position: 'relative', zIndex: 1 }}>
        <div ref={revealRef} className="reveal">
          <span className="section-label" style={{ color: 'var(--gold-light)' }}>Today's Specials</span>
          <h2 className="section-title" style={{ color: 'white' }}>
            What's On Today
          </h2>
          <p className="section-subtitle" style={{ color: 'rgba(255,255,255,0.6)' }}>
            Chef's daily selections, available now. Order ahead to guarantee yours before we sell out.
          </p>
        </div>

        {specials.length === 0 ? (
          <p style={{ color: 'rgba(255,255,255,0.5)', marginTop: '2rem' }}>
            Check back soon for today's specials.
          </p>
        ) : (
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))',
              gap: '1.4rem',
              marginTop: '2rem',
            }}
          >
            {specials.map((item) => (
              <SpecialCard key={item.id} item={item} formatPrice={formatPrice} onAddToCart={onAddToCart} />
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
